import React from 'react';
import { DefaultToast } from 'react-toast-notifications';

/**
 * Custom Toast that merges className from addToast options with the default
 * toast classes, so custom classes are additive rather than replacing.
 */
const CustomToast = (props) => {
  const { className: customClass, appearance = 'info', ...rest } = props;
  const baseClass = `react-toast-notifications__toast react-toast-notifications__toast--${appearance}`;
  const className = customClass ? `${baseClass} ${customClass}` : baseClass;

  return (
    <DefaultToast {...rest} appearance={appearance} className={className} />
  );
};

export default CustomToast;
